/* BuyMyBricks product page: gallery, dispatch line, lighting kit add-on, sticky bar,
   back-in-stock email to Klaviyo, GA4 events and the recently-viewed record.
   Ports the working parts of the live sections/bmb-product.liquid script (24 Sep 2026). */
(function () {
  var P = window.bmbProduct || {};

  // GALLERY: thumbs swap the main picture; the main picture opens a lightbox.
  var main = document.getElementById('gal-main'), lb = document.getElementById('bLB'), lbImg = document.getElementById('bLBImg');
  document.querySelectorAll('.gal__thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!main) return;
      main.src = b.dataset.src; main.removeAttribute('srcset'); main.dataset.full = b.dataset.full;
      document.querySelectorAll('.gal__thumbs button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    });
  });
  if (main && lb && lbImg) {
    function openLB() { lbImg.src = main.dataset.full || main.src; lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function closeLB() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    main.style.cursor = 'zoom-in';
    main.addEventListener('click', openLB);
    document.getElementById('bLBClose').addEventListener('click', closeLB);
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLB(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLB(); });
  }

  // DISPATCH LINE: honest about the clock. Working day and before 3pm UK time = today,
  // otherwise the next working day. England and Wales bank holidays for 2026 and 2027.
  (function () {
    var el = document.getElementById('bDisp'); if (!el || P.sourced) return;
    var bh = ['2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25', '2026-08-31', '2026-12-25', '2026-12-28',
              '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];
    function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
    function isW(d) { var dy = d.getDay(); return dy !== 0 && dy !== 6 && bh.indexOf(iso(d)) === -1; }
    function nW(d) { var n = new Date(d); n.setDate(n.getDate() + 1); while (!isW(n)) n.setDate(n.getDate() + 1); return n; }
    function fmt(d) { var D = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], M = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']; return D[d.getDay()] + ' ' + d.getDate() + ' ' + M[d.getMonth()]; }
    function upd() {
      var uk = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
      var h = uk.getHours(), m = uk.getMinutes();
      if (isW(uk) && h < 15) {
        var mins = (15 * 60) - (h * 60 + m), hl = Math.floor(mins / 60), ml = mins % 60;
        el.innerHTML = 'Order in the next <strong>' + (hl > 0 ? hl + 'h ' + ml + 'm' : ml + ' minutes') + '</strong> and it goes out today, tracked and insured.';
      } else {
        el.innerHTML = 'Next dispatch <strong>' + fmt(nW(uk)) + '</strong>. Order before 3pm and it goes out that day, tracked and insured.';
      }
    }
    upd(); setInterval(upd, 30000);
  })();

  // LIGHTING KIT ADD-ON: the tick relabels the button with the combined price; on submit both
  // items are added in one call and the customer lands in the basket.
  var form = document.getElementById('bForm'), lk = document.getElementById('bLK'), label = document.getElementById('bATCLabel'), atc = document.getElementById('bATC'), stickyP = document.getElementById('bStickyP');
  function money(p) { return '\u00a3' + (p / 100).toFixed(2); }
  function relabel() {
    if (!atc || !label) return;
    var base = Number(atc.dataset.base || 0), tot = lk && lk.checked ? base + Number(lk.dataset.price || 0) : base;
    label.textContent = 'Add to basket, ' + money(tot);
    if (stickyP) stickyP.textContent = money(tot);
  }
  if (lk) { lk.addEventListener('change', function () { relabel(); document.getElementById('bLKAddon').classList.toggle('is-on', lk.checked); }); relabel(); }
  if (form && lk) {
    form.addEventListener('submit', function (e) {
      if (!lk.checked) return;
      e.preventDefault();
      var vid = form.querySelector('[name=id]').value, qty = Number(document.getElementById('bQI').value) || 1;
      atc.disabled = true; label.textContent = 'Adding';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }, { id: Number(lk.dataset.vid), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { atc.disabled = false; relabel(); });
    });
  }

  // COOKIE BANNER: measure Shopify's consent banner while it is on screen so the sticky bar sits
  // just above it, and drops to the bottom edge the moment it is dismissed.
  (function () {
    function h() { var b = document.getElementById('shopify-pc__banner'); if (!b) return 0; var r = b.getBoundingClientRect(); return (r.height > 0 && getComputedStyle(b).display !== 'none' && getComputedStyle(b).visibility !== 'hidden') ? Math.round(r.height) : 0; }
    function set() { document.documentElement.style.setProperty('--cookie-h', h() + 'px'); }
    set();
    var n = 0, t = setInterval(function () { set(); if (++n > 40) clearInterval(t); }, 500);
    new MutationObserver(set).observe(document.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['style', 'class'] });
    window.addEventListener('resize', set);
  })();

  // STICKY BAR: appears once the real button has scrolled off; its button presses the real one.
  var sticky = document.getElementById('bSticky'), anchor = atc || document.getElementById('bis');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { sticky.classList.toggle('is-vis', !e[0].isIntersecting); }, { threshold: 0 }).observe(anchor);
  }
  var sb = sticky && sticky.querySelector('[data-sticky]');
  if (sb) sb.addEventListener('click', function () {
    if (sb.dataset.sticky === 'atc' && atc) { atc.click(); return; }
    var bis = document.getElementById('bis-email'); if (bis) { bis.scrollIntoView({ behavior: 'smooth', block: 'center' }); bis.focus(); }
  });

  // BACK IN STOCK: a "Requested back in stock" event is recorded with the set number (no list, no marketing consent).
  var bis = document.getElementById('bis');
  if (bis) bis.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = document.getElementById('bis-email').value.trim(), note = document.getElementById('bis-note'), btn = bis.querySelector('button');
    if (!email) return;
    var co = encodeURIComponent(bis.dataset.company), H = { 'Content-Type': 'application/json', revision: '2024-10-15' };
        btn.disabled = true; btn.textContent = 'Sending';
    // BMB-FORMS-FIXES-30SEP2026: this box records the "Requested back in stock" EVENT only. It no longer calls
    // client/subscriptions, so it adds no list membership and no email marketing consent (the old call
    // joined the marketing Email List and fired the Welcome flow). Profile is created by the event.
    var ev = fetch('https://a.klaviyo.com/client/events/?company_id=' + co, { method: 'POST', headers: H, body: JSON.stringify({ data: { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: 'Requested back in stock' } } }, profile: { data: { type: 'profile', attributes: { email: email } } }, properties: { set: bis.dataset.set, product: bis.dataset.title, url: location.href } } } }) });
    ev.then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status);
      btn.textContent = 'Done'; note.textContent = 'You are on the list for set ' + bis.dataset.set + '. One email when it is back.';
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Notify me';
      note.textContent = 'That did not go through. Email support@buymybricks.com with the set number and we will add you by hand.';
    });
  });

  // GA4, as the live page fires it.
  if (typeof gtag === 'function' && P.handle) {
    gtag('event', 'view_item', { currency: 'GBP', value: P.price, items: [{ item_id: P.handle, item_name: P.title, price: P.price, currency: 'GBP', quantity: 1 }] });
    if (form) form.addEventListener('submit', function () {
      var items = [{ item_id: P.handle, item_name: P.title, price: P.price, currency: 'GBP', quantity: 1 }];
      if (lk && lk.checked) items.push({ item_id: 'lighting-kit-' + P.handle, item_name: 'Lighting Kit for ' + P.title, price: Number(lk.dataset.price) / 100, currency: 'GBP', quantity: 1 });
      gtag('event', 'add_to_cart', { currency: 'GBP', value: items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0), items: items });
    });
  }

  // RECENTLY VIEWED: the last three, for the home page (RULES 10: max 3).
  try {
    if (P.handle) {
      var key = 'bmb_recent_v1', arr = [];
      try { arr = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) { arr = []; }
      arr = arr.filter(function (x) { return x && x.h && x.h !== P.handle; });
      arr.unshift({ h: P.handle, t: P.title, i: P.image, p: P.price, u: P.url, a: P.available });
      localStorage.setItem(key, JSON.stringify(arr.slice(0, 3)));
    }
  } catch (_) {}
})();

/* THE FULL DESCRIPTION, ON A PHONE (Peter, 25 Sep 2026: "everything is a bit big").
   Measured on the Defender at 390px: the product page ran to 15,737px and 7,236px of that was
   this one block, over eight screens of description sitting under a buy decision that was done
   by 2,000px. It is clamped to about a screen with a tap to open. Every word stays in the page,
   so a crawler and anyone who opens it get the lot; only the scroll is shortened. Desktop is
   untouched, and a short description is left alone. */
(function () {
  try {
    if (!window.matchMedia || !window.matchMedia('(max-width: 599px)').matches) return;
    var blocks = [].slice.call(document.querySelectorAll('.rte'));
    if (!blocks.length) return;
    var rte = blocks.sort(function (a, b) { return b.scrollHeight - a.scrollHeight; })[0];
    if (!rte || rte.scrollHeight < 900) return;
    rte.classList.add('is-clamped');
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'btn btn--secondary btn--block rte__more';
    more.textContent = 'Read the full description';
    more.setAttribute('aria-expanded', 'false');
    rte.parentNode.insertBefore(more, rte.nextSibling);
    more.addEventListener('click', function () {
      rte.classList.remove('is-clamped');
      more.setAttribute('aria-expanded', 'true');
      more.parentNode.removeChild(more);
    });
  } catch (e) {}
})();

/* SWIPE THE PICTURES ON A PHONE (Peter, 25 Sep 2026: "you can't even swipe on the phone you have
   to press the pictures"). The gallery was one static picture plus a strip you had to tap. On a
   phone the pictures now sit in a scroll-snap track, so a thumb swipe moves between them, the
   thumbnails still work as a jump-to, and the dots say where you are. Desktop is untouched, and
   a set with a single picture is left exactly as it was. Tapping still opens the lightbox. */
(function () {
  try {
    if (!window.matchMedia || !window.matchMedia('(max-width: 599px)').matches) return;
    var wrap = document.querySelector('.gal__main');
    var thumbs = [].slice.call(document.querySelectorAll('.gal__thumbs button'));
    var first = document.getElementById('gal-main');
    if (!wrap || !first || thumbs.length < 2) return;

    var srcs = thumbs.map(function (b) { return { src: b.dataset.src, full: b.dataset.full, alt: (b.querySelector('img') || {}).alt || '' }; });
    var track = document.createElement('div');
    track.className = 'gal__track';
    srcs.forEach(function (s, i) {
      var im = document.createElement('img');
      im.src = s.src; im.alt = s.alt; im.loading = i === 0 ? 'eager' : 'lazy';
      im.dataset.full = s.full;
      track.appendChild(im);
    });
    first.style.display = 'none';
    wrap.appendChild(track);
    wrap.classList.add('gal__main--swipe');

    var dots = document.createElement('div');
    dots.className = 'gal__dots';
    srcs.forEach(function (_, i) {
      var d = document.createElement('span');
      d.className = 'gal__dot' + (i === 0 ? ' is-on' : '');
      dots.appendChild(d);
    });
    wrap.parentNode.insertBefore(dots, wrap.nextSibling);

    var imgs = [].slice.call(track.children);
    var setActive = function (i) {
      [].slice.call(dots.children).forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
      // keep the lightbox pointing at whatever is on screen
      if (first && srcs[i]) first.dataset.full = srcs[i].full;
    };
    var onScroll = function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i >= 0 && i < imgs.length) setActive(i);
    };
    track.addEventListener('scroll', onScroll, { passive: true });
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }, true);
    });
    // A tap on the picture still opens the lightbox on the picture you are looking at.
    track.addEventListener('click', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      var lb = document.getElementById('bLB'), lbImg = document.getElementById('bLBImg');
      if (!lb || !lbImg || !srcs[i]) return;
      lbImg.src = srcs[i].full || srcs[i].src;
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  } catch (e) {}
})();
